<script>
import {defineComponent} from "vue";
export default defineComponent({
  layout: {name: 'AdminLayout'},
  setup() {
  },
})
</script>

<template>

</template>

<style scoped>

</style>